import React from "react";
import { Link } from "gatsby";
import Button from "../../atoms/button/button";

import "./paperEdition.scss";

export interface IPaperEdition {
  titulo: string;
  subTitulo: string;
  description: string;
  imageURL: string;
  botonText: string;
  botonLink: string;
}

const PaperEdition = (props: IPaperEdition) => {
  const {
    titulo,
    subTitulo,
    description,
    imageURL,
    botonText,
    botonLink,
  } = props;
  return (
    <div className="paper__edition">
      <img src={imageURL} alt="" />
      <div className="paper__edition-container">
        <h2 className="paper__edition-title">{titulo}</h2>
        <p className="paper__edition-description">{subTitulo}</p>
        <p className="paper__edition-ubication">{description}</p>
        <Link to={botonLink} target="_blank" rel="noreferrer">
          <Button
            type={"button"}
            classname="principal-button"
            text={botonText}
            isDisabled={false}
          />
        </Link>
      </div>
    </div>
  );
};

export default PaperEdition;
